export const INPUT_MAX_LENGTH = 104;
export const GRAPHIC_ORGANIZER_PARAM = "graphicOrganizer";
export const EXPORTABLES_PREVIEW_FORM_ID = "template-preview-form";
export const EXPORTABLES_PREVIEW_PRINTING_CLASSNAME = "printing";
export const EXPORTABLES_PREVIEW_DO_NOT_PRINT_CLASSNAME = "do-not-print";
